module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBold.92e27d7.woff";